// extracted by mini-css-extract-plugin
export default {"BookingRadioButton":"MoreSeatsRadioButton_BookingRadioButton__xB2tb"};